import { render, staticRenderFns } from "./invitation-modal.vue?vue&type=template&id=658a8397&scoped=true"
import script from "./invitation-modal.vue?vue&type=script&lang=js"
export * from "./invitation-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658a8397",
  null
  
)

export default component.exports